export default "__VITE_ASSET__bb3467f5__"